import axiosInstance from "./axiosInstance";

const verifyAccount = async (email: string, pin: string) => {
  try {
    const response = await axiosInstance.get(`/verify-link`, {
      params: {email, pin},
      validateStatus: () => true,
    });

    if (response.status === 200) {
      return response.data;
    }
    return null;
  } catch (error: any) {
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    throw new Error("Failed to verify account. Please try again.");
  }
};

export default verifyAccount;
